<template>
  <v-dialog
    :value="value"
    @input="onInput"
    width="423"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <v-card class="pb-4">
      <modal-title @close="$emit('input', false)">Group Details</modal-title>
      <group-modal-form
        @submit="onSubmit"
        :readonly="!group.is_admin"
        :value="group"
      ></group-modal-form>
    </v-card>
  </v-dialog>
</template>

<script>
import GroupModalForm from "./GroupModalForm.vue";
import ModalTitle from "@/components/ModalTitle";

export default {
  components: { GroupModalForm, ModalTitle },
  inheritAttrs: false,

  props: {
    group: {
      type: Object,
      required: true,
    },

    value: {
      type: Boolean,
    },
  },

  methods: {
    onInput(value) {
      this.$emit("input", value);
    },

    async onSubmit(group) {
      this.loading = true;
      try {
        await this.$store.dispatch("groups/editGroup", group);
        this.$store.dispatch("snackBar/showSnack", {
          text: `Group ${group.name} saved successfully`,
          color: "success",
          timeout: 4500,
        });
        this.$emit("close", true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
